style= require('./race-results.styl')
if match.season
  .wrapper.column
    .controls
      section
        a(href="/matches/" + match._id + "/lineups")
          ft-button(warning) Match Setup
        each source in matchSources
          if canScrapeLineups(source)
            ft-button(warning, (click)=this.scrapeLineups(source))
              | Scrape #{source.source}
        sporty-match-times(match=match)
        if canComputeAggregate
          ft-button(warning, (click)=this.computeAggregate())
            | Compute aggregate stats
        ft-button(success,
          (click)=this.sendFeeds(),
          disabled=match.$isSubmitting
        ) Send events
        ft-button(href=`/matches/${match._id}/feeds`)
            | Download Feed
      section
        each event in eventTypes
          .event(
            (click)=this.selectEventType(event),
            class=this.eventClass(event),
          )
            .name= this.eventName(event)
        ft-button(secondary, (click) = this.render(this.eventType = ''))= 'Reset events filter'
      section
        each period in match.batches
          ft-button(
            accent=period === batch,
            (click)=this.batch = period
          )= period
    .match
      sporty-status(match=match)
    .wrapper
      .wrapper.column
        label
          if hasShootingEvents
            | Hits
            each val in [5,4,3,2,1,0]
              .event(
                (click)=this.setHits(val),
                title=val + 'Misses',
                class=this.isSelected(val),
              )=val
          if hasJuryEvents
            .jury
              | Jury
              each player in players
                .player(
                  (click)=this.setActiveLineup(player),
                  title=player.lastName,
                  class=this.isGiver(player) ? 'selected' : ''
                )=player.lastName
                if isGiver(player)
                  each val in [12,10,8,7,6,5,4,3,2,1]
                    .event(
                      (click)=this.setJuryRank(val),
                      title='Rank ' + val,
                      class=this.isSelectedRank(val)
                    )=val + ' Points' + ' | ' + (this.receiver(player, val) || '')
                      ft-icon.cross(
                        (click)=this.findAndDestroy(player, val),
                        name="ui--cross"
                      )

        header
          h3= "Next position: " + (nextPosition || '')
          label
            | Override position
            ft-form-control(
              [(value)]= this.positionOverride,
              placeholder="Override position"
            )
          label
            | Search
            ft-form-control(
              [(value)]= this.search,
              placeholder="Search for name or team",
            )

        .unranked
          each lineup in unranked
            .player(
              (click)= hasJuryEvents ? this.addJuryRank(lineup) : this.addRank(lineup),
              title=lineup.player.fullName,
              class={submitting: lineup.$isSubmitting},
            )
              .name= lineup.player.name
              .team= '(' + (lineup.team && lineup.team.short) + ')'
    ft-button(
      success,
      (click)=this.editMode = !this.editMode
    )= this.editMode ? 'Cancel' : 'Edit stats'
    .wrapper
      .stats
        h3= match.sport === 'horses' ? 'Horses' : 'Riders'
        if match.periods
          each batch in match.batches
            - var batched = this.batched(batch)
            if batched.length
              header
                h3= 'Race ' + batch
              sporty-stats.block(
                match=match,
                batch=batch,
                edit-mode=editMode,
                exclude-positions=JSON.stringify(unrankable)
              )
          header
            h3 All Racers
        if !hasJuryEvents
          sporty-stats.block(
            match=match,
            edit-mode=editMode,
            eventType=eventTypes[0]
            exclude-positions=JSON.stringify(unrankable)
          )
        else
          each val in ['tier1', 'tier2', 'tier3', 'tier4','tier5']
            .stats
              h3=val
              sporty-stats.block(
                match=match,
                edit-mode=editMode,
                position=val,
              )
      for pos in ['manager', 'ctor']
        if showPos(match, pos)
          .stats
            h3= posTitle(pos)
            sporty-stats.block(
              match=match,
              edit-mode=editMode && ['cc_ski','alpine','biathlon'].includes(match.sport),
              position=pos,
            )
    sporty-feeds(match=match)
    if this.editMode
      ft-button(success, (click)=this.saveStats())
        | Save

  .eventsgroups
    .events
      .deleteButtons
        ft-button(
          warning,
          (click)=this.destroySelectedEvents(concatEvents(nameSortedEvents))
        )
          | Delete Selected
        each eventsByName in nameSortedEvents
          if eventsByName.length > 1 && eventsByName[0].name.split('_')[0] !== 'match'
            .deleteButtons
              ft-button(
                danger,
                (click)=this.destroyAllEvents(eventsByName)
              )
                | Delete All
          each event in (eventsByName || []).sort((a, b) => b.minute - a.minute)
            .event(class={submitting: event.$isSubmitting})
              if isResult(event)
                .rank= (event.minute % 1000) + '.'
              if event.player
                .name(title=event.player.fullName)= event.player.name
              .type= event.name
              ft-icon.delete(
                name="ui--cross",
                (click)=this.destroy(event)
              )
              if event?.name.split('_')[0] !== 'match'
                ft-toggle.eventSelected(
                  type="checkbox",
                  name=event.name,
                  checked=event.selected,
                  (toggle)=this.toggleSelected(event)
                )
